module.exports = __webpack_public_path__ + "img/pic2.40b68794.png";